// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: import.meta.env.VITE_KEYCLOAK,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

// Token kontrolü
const hasValidCachedToken = (): boolean => {
    const token = localStorage.getItem('access_token');
    const expires = localStorage.getItem('token_expires');

    if (!token || !expires) return false;

    const remainingMinutes = Math.floor((parseInt(expires) - Date.now()) / (1000 * 60));

    return remainingMinutes > 5;
};

// Token update'i tamamen blokla
const originalUpdateToken = keycloak.updateToken;
keycloak.updateToken = function (minValidity = 30) {
    if (hasValidCachedToken()) {
        return Promise.resolve(false); // Token yenilenmedi ama geçerli
    }

    return originalUpdateToken.call(this, minValidity);
};

export default keycloak;
